module.exports = __webpack_public_path__ + "img/FR19533.b94942f5.png";